/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AGREEMENT_BASE_ONLY_HOST",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256",
            },
        ],
        name: "APP_RULE",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_FLOW_RATE_ALLOWANCE_EXCEEDED",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_NEGATIVE_ALLOWANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_CREATE",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_FLOW_OPERATOR",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_UPDATE",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_CREATE_PERMISSIONS",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_DELETE_PERMISSIONS",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_UPDATE_PERMISSIONS",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ACL_UNCLEAN_PERMISSIONS",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_DEPOSIT_TOO_BIG",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_FLOW_ALREADY_EXISTS",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_FLOW_DOES_NOT_EXIST",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_FLOW_RATE_TOO_BIG",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_HOOK_OUT_OF_GAS",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_INSUFFICIENT_BALANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_INVALID_FLOW_RATE",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_NON_CRITICAL_SENDER",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_NO_SELF_FLOW",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ZERO_ADDRESS_RECEIVER",
        type: "error",
    },
    {
        inputs: [],
        name: "CFA_ZERO_ADDRESS_SENDER",
        type: "error",
    },
    {
        inputs: [],
        name: "OUT_OF_GAS",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        name: "CodeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "permissions",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96",
            },
        ],
        name: "FlowOperatorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "totalSenderFlowRate",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "totalReceiverFlowRate",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "FlowUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
        ],
        name: "FlowUpdatedExtension",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [],
        name: "CFA_HOOK_GAS_LIMIT",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_MINIMUM_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_FLOW_RATE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "existingPermissions",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "permissionDelta",
                type: "uint8",
            },
        ],
        name: "addPermissions",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "createFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "createFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "decreaseFlowRateAllowance",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "decreaseFlowRateAllowanceWithPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "deleteFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "deleteFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountFlowInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "getDepositRequiredForFlowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "getFlow",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "flowId",
                type: "bytes32",
            },
        ],
        name: "getFlowByID",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
        ],
        name: "getFlowOperatorData",
        outputs: [
            {
                internalType: "bytes32",
                name: "flowOperatorId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "flowOperatorId",
                type: "bytes32",
            },
        ],
        name: "getFlowOperatorDataByID",
        outputs: [
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
        ],
        name: "getMaximumFlowRateFromDeposit",
        outputs: [
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getNetFlow",
        outputs: [
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "increaseFlowRateAllowance",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "increaseFlowRateAllowanceWithPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "isPatricianPeriod",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isPatricianPeriodNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCurrentlyPatricianPeriod",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "existingPermissions",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "permissionDelta",
                type: "uint8",
            },
        ],
        name: "removePermissions",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "revokeFlowOperatorWithFullControl",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "updateFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "updateFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "updateFlowOperatorPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ConstantFlowAgreementV1__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ConstantFlowAgreementV1__factory.bytecode = _bytecode;
ConstantFlowAgreementV1__factory.abi = _abi;
//# sourceMappingURL=ConstantFlowAgreementV1__factory.js.map